export default __webpack_public_path__ + "static/media/credit-card-hover.56c08fa7.svg";